import { useEffect, useState } from "react";

// Seamless looping carousel. The slides are drawn three times; `pos` is the drawn position (it
// starts on the middle copy). Moving always animates one step in the direction asked — on the last
// chapter the first one already peeks in on the right and slides in next. When an animation ends
// outside the middle copy, the track jumps (unanimated) to the same chapter in the middle copy, so
// the user never sees it rewind.
const useLoopSlides = (count) => {
  const loop = count > 1;
  const [pos, setPos] = useState(loop ? count : 0);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    setAnimate(false);
    setPos(loop ? count : 0);
  }, [count, loop]);

  // re-enable the animation a frame after an unanimated jump
  useEffect(() => {
    if (animate) return undefined;
    let id2 = 0;
    const id1 = requestAnimationFrame(() => {
      id2 = requestAnimationFrame(() => setAnimate(true));
    });
    return () => {
      cancelAnimationFrame(id1);
      cancelAnimationFrame(id2);
    };
  }, [animate]);

  const index = loop ? ((pos % count) + count) % count : 0;
  const move = (delta) => {
    if (!loop || !delta) return;
    setAnimate(true);
    setPos((p) => p + delta);
  };
  // after a slide finishes: back to the middle copy if it ran past it
  const settle = () => {
    if (!loop || (pos >= count && pos < 2 * count)) return;
    setAnimate(false);
    setPos(count + index);
  };
  const copies = loop ? 3 : 1;
  return { pos, index, animate, move, settle, copies };
};

export default useLoopSlides;
